import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IChatBotHistory } from '../../../interface/interfaces';
import { CHAT_BOT_HISTORY } from '../../../constants/constants';

interface IInitialState {
    chatBotHistory: IChatBotHistory[];
}

// const chatBotHistoryStart: IChatBotHistory = {
//     role: "system"
// }

const storedChatBotHistory = localStorage.getItem(CHAT_BOT_HISTORY);
const initialChatBotHistory: IChatBotHistory[] = storedChatBotHistory ? JSON.parse(storedChatBotHistory) : [];

const initialState: IInitialState = {
    chatBotHistory: initialChatBotHistory,
};

const chatBotHistorySlice = createSlice({
    name: 'chatBotHistory',
    initialState,
    reducers: {
        addChatToHistory: (state: IInitialState, action: PayloadAction<IChatBotHistory[]>) => {
            state.chatBotHistory = action.payload;
            state.chatBotHistory = [...state.chatBotHistory, { role: 'system', blocks: [{block_type: 'text',  text: 'graph_id: demoday_freeze'}], additional_kwargs: {} }];
            localStorage.setItem(CHAT_BOT_HISTORY, JSON.stringify(action.payload));
        },

        clearChatHistory: (state: IInitialState) => {
            state.chatBotHistory = [];
            localStorage.removeItem(CHAT_BOT_HISTORY);
        },
    },
});

export default chatBotHistorySlice.reducer;
export const { addChatToHistory, clearChatHistory } = chatBotHistorySlice.actions;
